module.exports = __webpack_public_path__ + "media/components/Cards/images/metal_black-960a2e639785d4741c40af4a46a30a39.png";